import { RouteComponentProps } from "react-router";
import { interface___is_logged } from "../../../interfaces/interface.logged";

//	P R O P S

export interface props___SbDigitalMenuEditDishesPage extends RouteComponentProps<{ id: string; }>, interface___is_logged {

}

//	S T A T E

export interface state___SbDigitalMenuEditDishesPage {

	digitalmenu___id: string,
	digitalmenu___props: any | null,
	digitalmenu___props___isLoading: boolean,

	ionAlert___askForDeleteDish___isOpen: boolean,
	ionAlert___askForDeleteDish___argument: any | null,

	ionModal___MdDishEditModal___isOpen: boolean,
	ionModal___MdDishEditModal___target_id: string | null,
	ionModal___MdDishEditModal___target_category: string | null,

	ionToast___dishDeleted___isVisible: boolean,

}

//	S T A T E   D E F A U L T

export const state___SbDigitalMenuEditDishesPage___default: state___SbDigitalMenuEditDishesPage = {

	digitalmenu___id: '',
	digitalmenu___props: null,
	digitalmenu___props___isLoading: true,

	ionAlert___askForDeleteDish___isOpen: false,
	ionAlert___askForDeleteDish___argument: null,

	ionModal___MdDishEditModal___isOpen: false,
	ionModal___MdDishEditModal___target_id: null,
	ionModal___MdDishEditModal___target_category: null,

	ionToast___dishDeleted___isVisible: false,

}